import {
  CasePermissionSet,
  CaseTypePermissionSet,
  EngageReportingPermissionSet,
  FormPermissionSet,
  LetterPermissionSet,
  NylasAdminGrantPermissionSet,
  PermissionSetType,
  PlatformPermissionSet,
  SidebarProductVisibilityPermissionSet,
} from '../sets'
import { CommentPermissionSet } from '../sets/CommentPermissions'
import { EventPermissionSet } from '../sets/EventPermissions'
import { GroupPermissionSet } from '../sets/GroupPermissions'
import { RiderUserPermissionSet } from '../sets/RiderUserPermissions'
import { AdminMinimalRole } from './AdminMinimalRole'

export const AccessToEngageRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowEligibilityProduct,

  PlatformPermissionSet.ViewSensitiveInformation, // BETA, do not assume this is functional everywhere

  FormPermissionSet.Write,
  FormPermissionSet.WriteContents,
  FormPermissionSet.View,
  FormPermissionSet.ViewContents,

  LetterPermissionSet.Write,
  LetterPermissionSet.View,

  CaseTypePermissionSet.Write,
  CaseTypePermissionSet.View,

  CasePermissionSet.View,
  CasePermissionSet.ViewForms,
  CasePermissionSet.ViewLetters,
  CasePermissionSet.Write,
  CasePermissionSet.WriteForms,
  CasePermissionSet.WriteLetters,
  CasePermissionSet.WriteStatus,
  CasePermissionSet.ViewAppointments,
  CasePermissionSet.WriteAppointments,

  EngageReportingPermissionSet.View,
  EngageReportingPermissionSet.Write,
  EngageReportingPermissionSet.Delete,
  EngageReportingPermissionSet.Export,

  GroupPermissionSet.View,
  GroupPermissionSet.ViewMembership,
  GroupPermissionSet.ViewCondition,
  GroupPermissionSet.WriteMembership,
  GroupPermissionSet.ViewCondition,
  GroupPermissionSet.ImportMembership,
  GroupPermissionSet.ExportMembership,

  EventPermissionSet.View,

  CommentPermissionSet.View,
  CommentPermissionSet.Write,

  /* Rider user management */
  RiderUserPermissionSet.View,
  RiderUserPermissionSet.New,
  RiderUserPermissionSet.Edit,
  RiderUserPermissionSet.Archive,
  RiderUserPermissionSet.Delete,
  RiderUserPermissionSet.SetPhonePin,

  NylasAdminGrantPermissionSet.Auth,
  NylasAdminGrantPermissionSet.View,
  NylasAdminGrantPermissionSet.ViewOwn,
  NylasAdminGrantPermissionSet.WriteOwn,
]
